import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import 'datatables.net';

import { Talent } from '../../models/talent.model';
import { TalentService } from '../../services/talent.service'; 
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { UserManageService, Callback } from "../../services/cognito/cognito.service";
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { UserService } from '../../services/user.service';
import { TalentPoolService } from '../../services/talentpool.service'; 

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  @ViewChild('dt') dataTable;
  talentId;
  passedTalent;
  talents: Talent[] =[];
  talentDetails = [];
  talentDetail;
  sectorsCount;
  languagesArray;
  native;
  fluent;
  activeItem: number = 0;
  options;
  map;
  places;
  apiError;
  apiStatus;
  marker;
  place = {};
  result;
  markers = [];
  reloadCount = 0; 
  talentid;
  updatemessageSubscription;
  updateMessage = null;
  table;
  initFlag = 0;
  messageClass = '';
  public currentUser = JSON.parse(localStorage.getItem("user"));
  public selectedClient: string = (this.currentUser && this.currentUser.lastSelectedClient) ? this.currentUser.lastSelectedClient : "select";  	  
  public tableWidget: any;
  isClientSelected = false;
  animationTypes;
  loading =  false;
  txtSearch = '';
  token = "Htj8zuZAgr";
  mappedClient = null;
  clientTalentPools = [];
  talentPools = [];
  first = 0;

  constructor(private talentService: TalentService, 
              private route: ActivatedRoute,
              private userManagerService: UserManageService,
              private userService: UserService,
              private router: Router,
              private TalentPoolService: TalentPoolService) {   
    userService.getClientName.subscribe(user => this.changedClient(user)); 
      if (typeof this.currentUser.mappedClient !== 'undefined') { 
      this.mappedClient  = this.currentUser.mappedClient;
      }   

    
  }

  ngOnInit() {
    this.animationTypes = ANIMATION_TYPES;
    this.loading = true;    
    this.userService.headerTextChanged(null);
    this.userService.urlChanged(null);
    this.selectedClient = (this.currentUser && this.currentUser.lastSelectedClient) ? this.currentUser.lastSelectedClient : "select";
    window.scrollTo(0,0);

    this.userService.getUserById(this.mappedClient).subscribe(
      (response) => {
        let clientData = response.json().Result[0];
        this.clientTalentPools = clientData.talentPools;  
        this.TalentPoolService.getTalentPools()
        .then(
          (response) => {
            let talentPoolsAll = response.json().Result;
            this.talentPools = []; 
            for(let talentPool of this.clientTalentPools) {
              let clientTPool = talentPoolsAll.filter((tpool) => tpool.id == talentPool.id)[0];
              if(clientTPool) {
                this.talentPools.push(clientTPool);
              }              
            }   
            this.getTalents();
            //this.loading = false;
          },
          (error) => {
            this.messageClass = "danger";
            this.updateMessage = "Error: Oops! Something went wrong. Please refresh the page and try again.";  
            this.loading = false;
          }
        ); 
        //this.loading = false;
      },
      (error) => {
        this.messageClass = "danger";
        this.updateMessage = "Error: Oops! Something went wrong. Please refresh the page and try again.";  
        this.loading = false;
      }
    ); 
  } 

  closeAlert() {
    this.updateMessage = null;
  }

  getTalents() {
    this.talentService.getTalentsByClient(this.mappedClient,this.token)//this.selectedClient,this.token
      .subscribe(
        (response) => {
          this.talentDetails = response.json().Result;
          if(this.talentDetails) {
            for(let tdetails of this.talentDetails) {
              
              tdetails.talentPoolNames = (tdetails.talentPools) ? this.showTalentPoolNames(tdetails.talentPools) : '';   
              tdetails.jobFamilyNames =  (tdetails.jobFamilies) ? this.showFamilyNames(tdetails.jobFamilies) : ''; 
            }
          }
          
          if(localStorage.getItem("messageSuccess")){
            this.updateMessage = "Success: Talent has been updated successfully.";//params['message'];
            this.messageClass = "success";         
            localStorage.removeItem("messageSuccess");  

            if(localStorage.getItem("talentPageIndex")) {
              let talentPageIndex = parseInt(localStorage.getItem("talentPageIndex"));
              this.setCurrentPage(talentPageIndex);
            }
            // this.loading = false;   
          }

          this.loading = false;   
        },
        (error)  => {
          this.messageClass = "danger";
          this.updateMessage = "Error: Oops! Something went wrong. Please refresh the page and try again.";
         // console.log(error);
          this.loading = false;   
        } 
      ); 
  }

  deleterecruiterTalent(id:string) {  	
    this.loading = true;
    this.updateMessage = null;   
    this.talentService.deleteTalent(id).subscribe(
      (response) => { 
        if(response.json().StatusCode == 200) {
          this.messageClass = "success";
          this.updateMessage = "Success: Talent has been deleted successfully.";
          this.loading = false;                    
          this.ngOnInit();  
        } else {
          this.messageClass = "danger";
          this.updateMessage = "Error: Talent not deleted.";
          this.loading = false;   
        }                  
      },
      (error) => {
        this.messageClass = "danger";
        this.updateMessage = "Error: Oops! Something went wrong. Please refresh the page and try again.";
        this.loading = false;   
       // console.log(error);
      }
    );   
  }

  showModel(talentid:string){ 
    document.querySelector('body').classList.remove('modal-open');
    this.talentid = talentid;             
  }

  private changedClient(user): void {
    this.currentUser = user;    
    this.ngOnInit();
  }

  navigateAddTalent() {
    this.loading = true;
    this.router.navigate(['/recruiter/create-talent']);
  }

  showTalentPoolNames(talentPools) {
   // console.log(talentPools);
    let talentPoolNames = [];
    if(talentPools) {
      for(let talentPoolId of talentPools) {
        let selectedTalentPool = this.talentPools.filter((tpool) => tpool.id == talentPoolId)[0];
        if(selectedTalentPool) {
          talentPoolNames.push(selectedTalentPool.talentPool);
        }
      }
    }
    if(talentPoolNames.length > 0) {
      return talentPoolNames.join(", ");
    } else {
      return null;
    }
  }

  showFamilyNames(jobFamilies) {
    let familyNames = [];
    if(jobFamilies) {
      for(let family of jobFamilies) {
        let nameArray = family.split("***");

        let selectedTalentPool = this.talentPools.filter((tpool) => tpool.id == nameArray[0])[0];
        if(selectedTalentPool) {
          let selectedJobFamily = selectedTalentPool.jobFamilies.filter((jfamily) => jfamily.id == nameArray[1])[0];
          if(selectedJobFamily) {
            familyNames.push(selectedJobFamily.name);
          }
        }
      }     
    }

    if(familyNames.length > 0) {
      return familyNames.join(", ");
    } else {
      return null;
    }
  }

  setCurrentPage(n: number) {
    this.first = ((n - 1) * this.dataTable.rows);
  }

  paginate(event) {
    let pageIndex = event.first/event.rows + 1 // Index of the new page if event.page not defined.
    localStorage.setItem("talentPageIndex", pageIndex.toString());

  }
}



// WEBPACK FOOTER //
// ./src/app/recruiter/dashboard/dashboard.component.ts